export enum LocalPath {
  Home = '/',
  Webcam = '/webcam/',
  WebcamGuides = '/webcam/guides/',
  WebcamTest = '/',
  Headphones = '/headphones/',
  HeadphonesMusic = '/headphones/music/',
  HeadphonesReviews = '/headphones/reviews/',
  HeadphonesReview = '/headphones/review/',
  HeadphonesGuides = '/headphones/guides/',
  Mic = '/mic/',
  MicGuides = '/mic/guides/',
  MicTest = '/check-mic.html',
  HeadphonesFly = '/headphones/fly/',
  HeadphonesGenerator = '/headphones/generator/',
  Feedback = '/feedback/',
  Docs = '/docs/',
  DocsDevicesAccess = '/docs/devices-access/',
}
